import {
  MOST_SEARCHED_ADS_ATTEMPT,
  MOST_SEARCHED_ADS_SUCCESS,
  MOST_SEARCHED_ADS_FAILED,
} from "../types/mostSearchedAdsTypes";
import { LOGOUT } from "../types/adListTypes";

const INITIAL_STATE = {
  loading: false,
  loaded: false,
  list: [],
  error: "",
};

function mostSearchedAds(state = INITIAL_STATE, action) {
  switch (action.type) {
    case MOST_SEARCHED_ADS_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case MOST_SEARCHED_ADS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.data.list || [],
        error: "",
      };

    case MOST_SEARCHED_ADS_FAILED:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.error,
        list: [],
      };

    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default mostSearchedAds;
